import api from "./api.js";

export default class CurriculumApi {
  // ---------- 커리큘럼 ---------- //
  static async create(data) {
    return await api.post(`api/curriculum`, data);
  }

  static async getList(params) {
    return await api.get(`api/curriculum`, params);
  }

  static async delete(params) {
    return await api.del(`api/curriculum`, params);
  }

  static async getById(id) {
    return await api.get(`api/curriculum/${id}`);
  }

  static async update(id, data) {
    return await api.patch(`api/curriculum/${id}`, data);
  }

  static async order(id, data) {
    return await api.patch(`api/curriculum/order/${id}`, data);
  }
}
